// Patient Verification subsection questionnaire constants
export enum PatientVerificationQuestionnaireItem {
  PATIENT_VERIFICATION = 'patient-background/patient-verification',
  PATIENT_VERIFICATION_LEGAL_NAME = 'patient-background/patient-verification/legal-name',
  PATIENT_VERIFICATION_PREFERRED_NAME = 'patient-background/patient-verification/preferred-name',
  PATIENT_VERIFICATION_ADDRESS = 'patient-background/patient-verification/address',
  PATIENT_VERIFICATION_DOB = 'patient-background/patient-verification/dob',
  PATIENT_VERIFICATION_GENDER = 'patient-background/patient-verification/gender',
  PATIENT_VERIFICATION_MEDICAID_ID = 'patient-background/patient-verification/medicaid-id'
}
